import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchFantomRunPlays,
  selectFantomRunData,
  selectFantomRunError,
  selectFantomRunLoading,
  AppDispatch
} from '@/shared';

export const useFantomRun = (defaultLoading = true) => {
  const dispatch = useDispatch<AppDispatch>(); // Use the AppDispatch type for dispatch
  const fantomRun = useSelector(selectFantomRunData);
  const loading = useSelector(selectFantomRunLoading);
  const error = useSelector(selectFantomRunError);

  // Fetch season calendar on mount
  useEffect(() => {
    if (!fantomRun && defaultLoading) {
      dispatch(fetchFantomRunPlays());
    }
  }, [dispatch, fantomRun]);

  // Manual refresh
  const refresh = () => {
    if (!loading) {
      dispatch(fetchFantomRunPlays());
    }
  };

  const plays: number = fantomRun[0] || 0;
  const nextPlayAt: number = fantomRun[1] !== undefined ? fantomRun[1] : undefined;
  const isEnabled = fantomRun[2] || 0;
  return {
    plays,
    nextPlayAt,
    isEnabled,
    error,
    refresh
  };
};
